import { http } from "@next-core/http";
/**
 * @description 生成协作空间核心能力说明
 * @endpoint POST /api/v1/elevo/spaces/:spaceId/capabilities/generate
 */
export const ElevoSpaceApi_generateSpaceCapabilities = async (spaceId, data, options) => /**! @contract easyops.api.llm.elevo_space.GenerateSpaceCapabilities@1.0.0 */(await http.post(`api/gateway/logic.llm.aiops_service/api/v1/elevo/spaces/${spaceId}/capabilities/generate`, data, options)).data;
//# sourceMappingURL=generateSpaceCapabilities.js.map